import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const ItemsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 19V5H3V19H1ZM4 19V5H6V19H4ZM7 19V5H8V19H7ZM10 19V5H12V19H10ZM13 19V5H16V19H13ZM17 19V5H18V19H17ZM20 19V5H23V19H20Z" />
    </SvgIcon>
  );
};

export default ItemsIcon;
